import type { BucketKey } from '@/entities/bucket';
import request from '@/shared/api/request';

export const generateBucketsKeys = (): Promise<{ keys: BucketKey }> =>
  request({
    url: '/buckets/keys/',
    method: 'PUT',
  });
